const STORAGE_KEY_PREFIX = 'v2.product-get-started-dismissed.'

function storageKey(productId: string): string {
  return `${STORAGE_KEY_PREFIX}${productId}`
}

export function readV2ProductGetStartedDismissed(
  productId: string
): boolean {
  try {
    return window.localStorage.getItem(storageKey(productId)) === 'true'
  } catch {
    return false
  }
}

export function writeV2ProductGetStartedDismissed(productId: string): void {
  try {
    window.localStorage.setItem(storageKey(productId), 'true')
  } catch {
    // Ignore storage access failures.
  }
}
